import { Form, Modal, Pending } from '@finbeat/react-toolkit';
import { PaymentToClientInfo } from 'models/api/paymentsToClients';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Container,
    FormGroup,
    ModalBody,
    ModalHeader,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from 'reactstrap';
import { usePaymentsToClientsWorkplaceState } from '../PaymentsToClients';
import ClientTab from './Tabs/ClientTab';
import OrderTab from './Tabs/OrderTab';
import PaymentTab from './Tabs/PaymentTab';

export default function PaymentsToClientsModal({
    isOpen = false,
    toggle,
}: {
    isOpen: boolean;
    toggle: (val: boolean) => void;
}) {
    const { t } = useTranslation();
    const className = 'payment-to-client';
    const [activeTab, setActiveTab] = useState('client');
    const { currentItem } = usePaymentsToClientsWorkplaceState();

    const closeModal = () => {
        toggle(false);
    };

    return (
        <Modal size="xl" isOpen={isOpen} toggle={closeModal} scrollable className={className}>
            {!currentItem ? (
                <Pending />
            ) : (
                <Form<PaymentToClientInfo> defaultValues={currentItem} className="form-in-modal">
                    <ModalHeader toggle={closeModal}>{t('BackOfficePaymentToClient')}</ModalHeader>
                    <ModalBody className={`${className}__body`}>
                        <Container className={`${className}__container`}>
                            <FormGroup>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            href="#"
                                            onClick={() => setActiveTab('client')}
                                            active={activeTab === 'client'}
                                        >
                                            {t('BackOfficeClient')}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href="#"
                                            onClick={() => setActiveTab('order')}
                                            active={activeTab === 'order'}
                                        >
                                            {t('BackOfficeOrder')}
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            href="#"
                                            onClick={() => setActiveTab('payment')}
                                            active={activeTab === 'payment'}
                                        >
                                            {t('BackOfficePayment')}
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </FormGroup>
                            <div className={`${className}__content-card custom-scrollbar mb-3`}>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="client">
                                        <ClientTab />
                                    </TabPane>
                                    <TabPane tabId="order">
                                        <OrderTab />
                                    </TabPane>
                                    <TabPane tabId="payment">
                                        <PaymentTab toggle={closeModal} />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Container>
                    </ModalBody>
                </Form>
            )}
        </Modal>
    );
}
